import $ from "jquery";
import breadcrumb from "#templates/pages/breadcrumb";
import content from "#templates/pages/content";
import language from "#scripts/translation";
// import "#npm/@prokomssp/fantdu/dist/fantdu.min";
import "../../../node_modules/@prokomssp/fantdu/dist/fantdu.min";

export default function () {
	const breadcrumbHtml = breadcrumb();
	// document.title = 'Nyheter';
	const nameId = window.serverdata.configMeta.aim.nameId || "";
	const fantduCss = `
    #feedback {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .fant-du__heading {
        font-size: var(--fantdu__heading_font-size, 1.5rem);
        font-weight: var(--fantdu__heading_font-weight, bold);
    }
    button.fant-du__button--yes {
        border-color: var(--fantdu__button__yes__border-color, var(--fantdu__button__border-color, var(--primary__color)));border-radius: var(--fantdu__button__border-radius, 0);;
    }
    button.fant-du__button--no {
        border-color: var(--fantdu__button__no__border-color, var(--fantdu__button__border-color, var(--primary__color)));border-radius: var(--fantdu__button__border-radius, 0);;
    }
    input.fant-du__input,
    textarea.fant-du__textarea {
        background-color: #ffffff;
        min-width: 303px;
    }
    .fant-du__textarea:focus {
      box-shadow: 0 0 0 3px #385dff;
      outline: none;
    }
  `;

	content();
	window.fantdu__success = (result) => {
		let traces = [];

		for (const data of result.trace.$values) {
			const time = data.timeOut / 1000;

			traces.push(`
                <li>${time} sek, <a href="${decodeURIComponent(data.pageUrl)}">${decodeURIComponent(data.pageName)}</a></li>
           `);
		}

		let comment = "";

		if (result.comment.length > 0) {
			comment = `${result.comment}`;
		}

		traces = traces.join("");

		const fantduComment = `<span class="badge badge-${result.isPositive ? 'success">Positiv' : 'danger">Negativ'}</span>
            <br/>
            ${comment}
            ${window.serverdata.configMeta.aim?.fantduAskForEmail && result.epost !== undefined ? `<br/><h6>E-post:</h6>${result.epost}` : ""}
            <br/><br/>
						<h6>Sporing:</h6>
            <ol>
            ${traces}
            </ol>
        `;

		const data = {
			taskFinished: false,
			taskDescription: fantduComment,
			title: `Fantdu (${result.isPositive ? "Positiv" : "Negativ"}) ${comment.length < 1 ? "Ingen kommentar" : `${comment.slice(0, 20)}...`}`,
			subscriptionId: window.contentSubscription,
			// contentId: window.contentID,
			contentId: window.articleParsed.contentId,
			taskState: 0,
			taskType: "FantDu",
		};

		// console.log("data fantdu: ", data);
		const senddata = JSON.stringify(data);

		// Get JSON
		$.ajax({
			type: "POST",
			url: `${window.apiUrl}/UserTaskApi/create`,
			contentType: "application/json-patch+json",
			data: senddata,
			headers: { subscriptionId: window.serverdata.configMeta.aim.clientId },
		}).done((alle) => { });
	};

	window.fandu__failed = (result) => {
		let traces = [];

		for (const data of result.trace.$values) {
			const time = data.timeOut / 1000;

			traces.push(`
                <li>${time} sek, <a href="${data.pageUrl}">${data.pageName}</a></li>
           `);
		}

		let comment = "";

		if (result.comment.length > 0) {
			comment = `${result.comment}`;
		}

		traces = traces.join("");

		const fantduComment = `
            Fantdu feilet, returnerer res etter stat:<br>
            <span class="badge badge-${result.isPositive ? 'success">Positiv' : 'danger">Negativ'}</span>
            <br/>
            ${comment}
            ${window.serverdata.configMeta.aim?.fantduAskForEmail && result.epost !== undefined ? `<br/><h6>E-post:</h6>${result.epost}` : ""}
            <br/><br/>
            <h6>Sporing:</h6>
            <ol>
            ${traces}
            </ol>
        `;

		const data = {
			taskFinished: false,
			taskDescription: fantduComment,
			title: `Fantdu (${result.isPositive ? "Positiv" : "Negativ"}) ${comment.length < 1 ? "Ingen kommentar" : `${comment.slice(0, 20)}...`}`,
			subscriptionId: window.contentSubscription,
			contentId: window.articleParsed.contentId,
			taskState: 0,
			taskType: "FantDu",
		};

		const senddata = JSON.stringify(data);

		// Get JSON
		$.ajax({
			type: "POST",
			url: `${window.apiUrl}/UserTaskApi/create`,
			contentType: "application/json-patch+json",
			data: senddata,
		}).done((alle) => { });
	};

	const askForEmail = window.serverdata.configMeta.aim?.fantduAskForEmail ? 'ask-for-email="true"' : "";
	return `
        <div class="container p-md-0">
            ${breadcrumbHtml}
        </div>
        <div class="container p-md-0 article" id="contentHtml">
                <div class="row">
                    <div class="col-sm-12 text-center">
                        <div class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
        </div>
        ${window.serverdata.configMeta.aim?.doNotUseFantdu
			? ""
			: `
        <div class="fant_du_container">
            <fant-du client="${nameId}" ${askForEmail} 
							title-text="${language("FANTDU_TITLE")}" 
							second-title-text="${language("FANTDU_TITLE2")}" 
							placeholder-text="${language("FANTDU_PLACEHOLDER")}" 
							email-invitation-text="${language("FANTDU_EMAIL_PLACEHOLDER")}" 
							send-in-text="${language("FANTDU_SEND_BUTTON")}" 
							yes-text="${language("FANTDU_YES")}" 
							no-text="${language("FANTDU_NO")}" 
							pre-textarea-text="${language("FANTDU_PRETEXT")}" 
							post-message="${language("FANTDU_POSTTEXT")}"
							receipt-text-content="${language("FANTDU_EYOK")}"
							onSubmitSuccess="fantdu__success" onSubmitFail="fandu__failed" css="${fantduCss}"></fant-du> 
        </div>`
		}
        `;
}
